if (!customElements.get('gf-product-share')) {
  customElements.define('gf-product-share', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-share-open]');
      this.status = this.querySelector('.gf-share__status');
      this.manual = this.querySelector('.gf-share__manual');
      this.input = this.manual.querySelector('input');
      this.native = this.querySelector('[data-share-native]');
      this.urlToShare = this.cleanUrl(this.dataset.productUrl, this.dataset.variant);
      if (!this.dialog.showModal) return;
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-share-close]').addEventListener('click', () => this.close(), options);
      this.querySelector('[data-share-copy]').addEventListener('click', () => this.copy(), options);
      this.native.addEventListener('click', () => this.shareNative(), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('close', () => this.finishClose(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, options);
      this.refreshLinks();
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }

    cleanUrl(value, variant) {
      const base = new URL(this.dataset.productUrl, location.origin);
      const supplied = new URL(value, base);
      const selected = variant || supplied.searchParams.get('variant');
      base.search = '';
      base.hash = '';
      if (/^\d+$/.test(selected || '')) base.searchParams.set('variant', selected);
      return base.href;
    }

    updateUrl(value) {
      this.urlToShare = this.cleanUrl(value);
      this.refreshLinks();
    }

    refreshLinks() {
      const title = this.dataset.productTitle;
      this.querySelector('[data-share-whatsapp]').href = `https://wa.me/?text=${encodeURIComponent(`${title}\n${this.urlToShare}`)}`;
      this.querySelector('[data-share-email]').href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${title}\n${this.urlToShare}`)}`;
      this.input.value = this.urlToShare;
      let supported = typeof navigator.share === 'function';
      try {
        if (supported && navigator.canShare) supported = navigator.canShare({ title, url: this.urlToShare });
        const policy = document.permissionsPolicy || document.featurePolicy;
        if (supported && policy?.allowsFeature) supported = policy.allowsFeature('web-share');
      } catch { supported = false; }
      this.native.hidden = !supported;
      this.querySelector('.gf-share__actions').classList.toggle('gf-share__actions--native', supported);
    }

    open() {
      if (this.dialog.open) return;
      const variant = this.closest('.gf-product-page')?.querySelector('form[id^="product-form-"] input[name="id"]')?.value;
      if (/^\d+$/.test(variant || '')) this.urlToShare = this.cleanUrl(this.dataset.productUrl, variant);
      this.refreshLinks();
      this.status.textContent = '';
      this.manual.hidden = true;
      this.lockScroll();
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      this.querySelector('h2').focus({ preventScroll: true });
    }

    close() { this.dialog.close(); }

    finishClose() {
      this.unlockScroll();
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }

    lockScroll() {
      if (this.scrollState) return;
      this.scrollState = {
        x: window.scrollX, y: window.scrollY,
        rootOverflow: document.documentElement.style.overflow,
        bodyOverflow: document.body.style.overflow,
        position: document.body.style.position,
        top: document.body.style.top,
        width: document.body.style.width
      };
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollState.y}px`;
      document.body.style.width = '100%';
    }

    unlockScroll() {
      if (!this.scrollState) return;
      const state = this.scrollState;
      document.documentElement.style.overflow = state.rootOverflow;
      Object.assign(document.body.style, { overflow: state.bodyOverflow, position: state.position, top: state.top, width: state.width });
      window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
      this.scrollState = null;
    }

    async copy() {
      this.status.textContent = '';
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(this.urlToShare);
        if (!this.dialog.open) return;
        this.manual.hidden = true;
        this.status.textContent = this.dataset.copied;
      } catch {
        if (!this.dialog.open) return;
        this.manual.hidden = false;
        this.status.textContent = this.dataset.copyHelp;
        this.input.focus({ preventScroll: true });
        this.input.select();
      }
    }

    async shareNative() {
      this.status.textContent = '';
      try {
        await navigator.share({ title: this.dataset.productTitle, url: this.urlToShare });
        if (this.dialog.open) this.status.textContent = this.dataset.shared;
      } catch (error) {
        if (error.name !== 'AbortError' && this.dialog.open) this.status.textContent = this.dataset.shareError;
      }
    }
  });
}
